export const GENERAL_VITAL_SIGN_CONSTANTS = {
  heading: 'Signos Vitales y Mediciones',
  temperature: 'Temperatura C',
  bloodPressure: 'Presión arterial (mm Hg.)',
  pulse: 'Pulso/min',
  breathingFrequency: 'Frecuencia respiratoria',
  weight: 'Peso Kg',
  height: 'Talla/cm',
  glucose: 'Glucosa (mg/dl)',
  oxygenSaturation: 'Saturación oxígeno',
  headCircumference: 'Perimetro cefálico/cm'
};
